import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { Button, Input } from '../../../UI'

const TupUpPaymentModalPromoCode = ({ onApply }) => {
  const { reset, register, handleSubmit } = useForm({
    defaultValues: {
      code: '',
    },
  })

  const [isFormOpen, setIsFormOpen] = useState(false)

  const handleToggleForm = () => {
    setIsFormOpen((prevState) => !prevState)

    reset()
  }

  const handleFormSubmit = (data) => {
    console.log(data)

    onApply(data)
  }

  return (
    <div className="w-full flex flex-col items-start">
      <button
        type="button"
        className="text-base font-bold text-primary-button"
        onClick={handleToggleForm}
      >
        Have a promo code?
      </button>

      {isFormOpen && (
        <form
          onSubmit={handleSubmit(handleFormSubmit)}
          className="w-full mt-[10px] flex gap-x-[10px]"
        >
          <Input
            type="text"
            placeholder="Enter promo code"
            className="h-[56px] flex-1 text-primary-100"
          />

          <Button type="submit" className="!font-bold w-[148px] !p-0">
            Apply
          </Button>
        </form>
      )}
    </div>
  )
}

export default TupUpPaymentModalPromoCode
